import './contact.css';
import paddy1 from '../assets/Links/Paddy_2.png';
import paddy2 from '../assets/Links/Paddy_1.png';
import NavBar from '../components/NavBar';
import React, {useState,useEffect} from 'react';
import Footer from '../components/Footer';
import ScrollArrow from '../components/ScrollArrow';
import BackToTop from '../components/BackToTop';


const Contact = () => {
  const email = "srivelmrm@gmail.com";
    const phone = "04257 247666";
    const [showArrow, setShowArrow] = useState(true);
      useEffect(() => {
        const handleScroll = () => {
          const scrollY = window.scrollY;
          setShowArrow(scrollY < 50); // show only at top
        };
    
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
      }, []);
  
  const handleCopyClick = (text, label) => {
    navigator.clipboard.writeText(text).then(() => {
      alert(`${label} copied to clipboard!`);
    });
  };
  const scrollToNextSection = () => {
    window.scrollTo({
      top: window.innerHeight,
      behavior: "smooth",
    });
  };
  return (
    <div className="page-wrapper-contact">
      <NavBar />
      <div className='contact-banner'>
        <div className="side-image paddy1">
                        <img src={paddy1} alt="Left" className="side-image left-image" />
                      </div>
        <div className="contact-banner-image">
          {/* <img src={millImage} alt="Contact Banner" className="contact-banner-image" /> */}
          </div>
        <div className="side-image paddy2">
                        <img src={paddy2} alt="Right" className="side-image right-image" />
                      </div>
                      {showArrow && (
                      <ScrollArrow onClick={scrollToNextSection} />)}
        </div>
      <div className="contact-wrapper">
        <h2 className='primary-heading'>CONTACT US</h2>
          <h3>SHRIVEL HITECH RICE INDUSTRIES</h3>
          <p>
            331/2, Kovai Road, Kadaiyur (Post), <br/>Kangayam – 638701, Tirupur District, Tamilnadu, India
            <br />
            Email: {" "}
            <button
  type="button"
  onClick={() => handleCopyClick(email, "Email")}
  style={{
    background: "none",
    border: "none",
    padding: 0,
    margin: 0,
    color: "black",
    textDecoration: "none",
    cursor: "pointer",
    font: "inherit" // keeps same font style as surrounding text
  }}
>
  {email}
</button>

            <br />
            Customer Care No: {" "}
            <button
  type="button"
  onClick={() => handleCopyClick(phone, "Customer Care Number")}
  style={{
    background: "none",
    border: "none",
    padding: 0,
    margin: 0,
    color: "black",
    textDecoration: "none",
    cursor: "pointer",
    font: "inherit" // keeps same font style
  }}
>
  {phone}
</button>

            </p>
            <div className='contact-map'>
              <iframe src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d3916.7851060301946!2d77.5172745!3d10.9795866!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e3!4m0!4m5!1s0x3ba99f550b47e795%3A0xed2a54d4f8608037!2sShrivel%20Hi-Tech%20Rice%20Industries%2C%20331%2F2%2C%20Kovai%20Road%2C%20Kadaiyur%2C%20Kangeyam%2C%20Tamil%20Nadu%20638701!3m2!1d10.979796!2d77.51660969999999!5e0!3m2!1sen!2sin!4v1755171380806!5m2!1sen!2sin" 
              width="100%"
    height="500"
    style={{ border: 0 }}
    allowFullScreen
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
    title="Shrivel Hi-Tech Rice Industries Location Map"></iframe>
              </div>
              
           
        </div>
        <BackToTop/>
        <Footer />
    </div>
  );
};

export default Contact;
